export default __webpack_public_path__ + "static/media/unitjs.b680b83f.svg";